import style from './redo-icon.module.less';

export const RedoIcon = () => (
  <svg className={style['redo-icon']} fill='none' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M1.65859 12.9487C2.31457 11.3023 3.36505 9.98798 4.81002 9.0056C6.25499 8.02324 7.86315 7.53206 9.6345 7.53206C10.9304 7.53206 12.1537 7.81011 13.3044 8.36621C14.455 8.92231 15.4369 9.70142 16.2499 10.7036L16.2499 7.5L17.4999 7.5L17.4999 12.9487L12.0512 12.9487L12.0512 11.6987L15.4631 11.6987C14.7708 10.7789 13.9155 10.0628 12.8974 9.55048C11.8792 9.03819 10.7942 8.78204 9.64252 8.78204C8.22051 8.78204 6.91575 9.15704 5.72825 9.90704C4.54075 10.657 3.63878 11.6709 3.02233 12.9487L1.65859 12.9487Z'
      fill='currentColor'
    />
  </svg>
);
